import Vue from 'vue'
import Vuex from 'vuex'
import AuthModule from './modules/Auth/AuthModule'
import CashDeskModule from './modules/CashDesk/CashDeskModule'
import CashMovementModule from './modules/CashMovement/CashMovementModule'
import CloseCashModule from './modules/CloseCash/CloseCashModule'
import UniqueKeyModule from './modules/UniqueKey/UniqueKeyModule'
import SnackbarModalModule from './modules/SnackbarModal/SnackbarModalModule'
import CustomerModule from './modules/Customer/CustomerModule'
import PaymentSummariesModule from './modules/PaymentSummaries/PaymentSummatiesModule'
import CashierModule from './modules/Cashier/CashierModule'
import CustomerPaymentModule from './modules/CustomerPayment/CustomerPaymentModule'
import IntegrationModule from './modules/Integration/IntegrationModule'
import rendition from './modules/Rendition/rendition'
import SessionModule from './modules/Session/SessionModule'
Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        AuthModule,
        CashDeskModule,
        SnackbarModalModule,
        CashMovementModule,
        UniqueKeyModule,
        CustomerModule,
        PaymentSummariesModule,
        CashierModule,
        CloseCashModule,
        CustomerPaymentModule,
        IntegrationModule,
        rendition,
        SessionModule,
    },
    state: {},
    actions: {},
})
